import React, { useEffect, useState, useRef } from 'react';
import * as Yup from 'yup';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Row,
  Col,
} from 'reactstrap';
import { Formik, Field } from 'formik';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import FormikInputField from 'components/common/Fields/FormikInputField';

const validationSchema = Yup.object({
  accessLevel: Yup.string().required('Access Level is a required'),
  firstName: Yup.string().required('First Name is a required'),
  lastName: Yup.string().required('Last Name is a required'),
  emailID: Yup.string().email('Invalid email').required('Email is a required'),
  role: Yup.string().required('Role is a required'),
});

const accessLevelOption = [{ id: 1, label: 'Organisation' }];
const roleOption = [
  { id: 'Organisation Admin', label: 'Admin' },
  { id: 'users', label: 'Users' },
];
const statusOpt = [
  { id: 1, label: 'Active' },
  { id: 2, label: 'Inactive' },
  { id: 3, label: 'Locked' },
];

const UserAddEditModal = ({ modalKey, isModalOpen, toggle, rowData }) => {
  const [state, updateState] = useState({
    initialValues: {
      accessLevel: '',
      firstName: '',
      lastName: '',
      emailID: '',
      role: '',
      status: ''
    },
    hasReset: false
  });

  const formikRef = useRef();

  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

  useEffect(() => {
    updateInitialValues();
  }, [modalKey]);

  const updateInitialValues = () => {
    if (modalKey === 'ADD') {
      return setState({
        initialValues: {
          accessLevel: '',
          firstName: '',
          lastName: '',
          emailID: '',
          role: '',
          status: 'Active'
        },
      });
    } else {
      if (!rowData) return;
      const { accessLevel, firstName, lastName, emailID, role, status } = rowData;
      console.log(accessLevel);
      setState({
        initialValues: {
          accessLevel,
          firstName,
          lastName,
          emailID,
          role,
          status
        },
      });
    }
  };

  const handleSubmit = async(val, action) => {
    if(state.hasReset){
      formikRef.current.resetForm();
      setState({
        hasReset: false
      });
    }else{
      toggle()
    }
  };

  const onHandleSubmit = (hasReset = false) => {
   
    if (formikRef.current) {
      setState({
        hasReset: hasReset
      })
       formikRef.current.handleSubmit();
    }
  }

  const { initialValues } = state;

  return (
    <div>
      <Modal isOpen={isModalOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {modalKey === 'ADD' ? 'New User Registration' : 'User Details'}
        </ModalHeader>
        <ModalBody>
          <Formik
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            initialValues={initialValues}
            enableReinitialize={true}
            innerRef={formikRef}
            children={(props) => {
              return (
                <div>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label for="accessLevel">Access Level</Label>
                        <Field
                          name="accessLevel"
                          type="text"
                          className="required"
                          component={FormikSelectField}
                          options={accessLevelOption}
                          defaultoption="--Select--"
                          keys={{
                            id: 'label',
                            label: 'label',
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label for="firstName">First Name</Label>
                        <Field
                          id="firstName"
                          name="firstName"
                          type="text"
                          className="required"
                          autoComplete="off"
                          component={FormikInputField}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label for="lastName">Last Name</Label>
                        <Field
                          id="lastName"
                          name="lastName"
                          type="text"
                          className="required"
                          autoComplete="off"
                          component={FormikInputField}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label for="email">Email</Label>
                        <Field
                          id="email"
                          name="emailID"
                          type="email"
                          className="required"
                          autoComplete="off"
                          component={FormikInputField}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label for="role">Role</Label>
                        <Field
                          name="role"
                          type="text"
                          className="required"
                          component={FormikSelectField}
                          options={roleOption}
                          defaultoption="--Select--"
                          keys={{
                            id: 'id',
                            label: 'label',
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label for="status">Status</Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    {statusOpt?.map((item) => {
                      return (
                        <Col key={item.id}>
                          <Label for={item.label}>{item.label}</Label>
                          <Field
                            id={item.label}
                            name="status"
                            type="radio"
                            component={FormikInputField}
                            value={item.label}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              );
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggle}>
            CANCEL
          </Button>{' '}
          <Button color="primary" onClick={() =>onHandleSubmit(false)}>
            SAVE
          </Button>
          {modalKey === 'ADD' && (
            <Button color="primary" onClick={() => onHandleSubmit(true)} >
              SAVE AND ADD ANOTHER
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default UserAddEditModal;
